/**
 * Імена іконок зі спрайту (див. components/IconSprite.svelte).
 *
 * Список згенерований із mockup/index.html — тримати його в TypeScript, а не
 * в рядках по компонентах, потрібно для однієї речі: описка в назві іконки
 * інакше не падає й не помітна, вона просто рендерить порожній <svg>.
 * З цим типом `<Icon name="hosue" />` не збереться.
 */
export const ICON_NAMES = [
  'house',
  'library-big',
  'message-circle',
  'calendar-days',
  'user-round',
  'chart-column',
  'users-round',
  'clapperboard',
  'gift',
  'audio-lines',
  'circle-play',
  'file-text',
  'image',
  'calendar',
  'sunrise',
  'leaf',
  'droplet',
  'flame',
  'flower-2',
  'wind',
  'salad',
  'lock',
  'heart',
  'triangle-alert',
  'check',
  'monitor-play',
  'circle-help',
  'crown',
  'credit-card',
  'shield-check',
  'play',
  'maximize',
  'settings-2',
  'sliders-horizontal',
  'square-pen',
  'eye',
  'trash-2',
  'link',
  'cloud-upload',
  'sparkles',
  'menu',
  'moon',
  'sun',
  'grip-vertical',
  'x',
  'arrow-left',
  'arrow-right',
  'chevron-right',
  'chevron-left',
  'search',
  'plus',
  'flag',
  'ellipsis',
  'pause',
  'volume-2',
  'volume-x',
  'rotate-ccw',
  'rotate-cw',
  'airplay',
  'picture-in-picture-2',
  'minimize',
] as const;

export type IconName = (typeof ICON_NAMES)[number];

/** Іконки, які має сенс вибирати для розділу в адмінці (D6 плану переносу).
 *  Решта спрайту — службовий UI: стрілки, хрестики, олівці. */
export const CATEGORY_ICON_NAMES = [
  'sunrise',
  'leaf',
  'droplet',
  'flame',
  'flower-2',
  'wind',
  'salad',
  'audio-lines',
  'circle-play',
  'file-text',
  'heart',
  'sparkles',
  'crown',
  'shield-check',
  'monitor-play',
  'calendar-days',
] as const satisfies readonly IconName[];

/** Іконка типу матеріалу. Була продубльована локальною мапою в п'яти
 *  сторінках — тепер одна на застосунок, щоб відео скрізь виглядало відео. */
export const MATERIAL_TYPE_ICONS = {
  video: 'circle-play',
  audio: 'audio-lines',
  text: 'file-text',
} as const satisfies Record<'video' | 'audio' | 'text', IconName>;
